import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackChargingCostDetailsClickEventData } from './legacy-types';

interface UseLegacyTrackChargingCostDetailsClickVariables {
  information: {
    context: 'modal';
    disance: string;
    chargingCost?: number;
  };
}

export const createLegacyTrackChargingCostDetailsClick = (
  variables: UseLegacyTrackChargingCostDetailsClickVariables,
): LegacyTrackChargingCostDetailsClickEventData => {
  const eventData: LegacyTrackChargingCostDetailsClickEventData = {
    eventType: 'chargingCostDetailsClick',
    pageType: 'product page',
    information: variables.information,
  };

  return eventData;
};

export const useLegacyTrackChargingCostDetailsClick = () => {
  const { track } = useLegacyTracking();

  const trackLegacyChargingCostDetailsClick = useCallback(
    (variables: UseLegacyTrackChargingCostDetailsClickVariables) => {
      track({
        event: 'chargingCostDetailsClick',
        data: createLegacyTrackChargingCostDetailsClick(variables),
      });
    },
    [track],
  );

  return {
    trackLegacyChargingCostDetailsClick,
  };
};
